import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetMedicineUsedAsDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/MedicineUsedAs/GetDetail?` + params, null);

export const GetMedicineUsedAsList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/MedicineUsedAs/GetList?` + params, null);

export const CreateMedicineUsedAs = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MedicineUsedAs/Create`, data);

export const UpdateMedicineUsedAs = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MedicineUsedAs/Update`, data);

export const DeleteMedicineUsedAs = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MedicineUsedAs/Delete`, data);






